import React from 'react';
import { IconButton, IconMenu, MenuItem } from 'material-ui';
import MoreHorizIcon from 'material-ui/svg-icons/navigation/more-horiz';
import _ from 'lodash';
import { grey400 } from 'material-ui/styles/colors';
import classNames from 'classnames';
import Translate from 'translate';

const iconButtonHorizontal = (
  <IconButton touch tooltipPosition="bottom-left">
    <MoreHorizIcon color="#666666"/>
  </IconButton>
);

export default ( { className, onClickResponse, options, disabled, text = true, icon } ) => {

  return (
    <div className={classNames( 'd-flex align-items-center color-gray-4 font-weight-light', className )}>
      {text && <Translate id="predefinedAnswers"/>}
      <IconMenu iconButtonElement={icon || iconButtonHorizontal}>
        {_.map( options, ( response ) =>
          <MenuItem key={response.id} disabled={disabled}
                    style={{padding: 5, color: '#333333', lineHeight: '30px', minHeight: 30}}
                    onClick={() => onClickResponse( response.description )}>
            {response.name}
          </MenuItem>
        )}
      </IconMenu>
    </div>
  )
}



// WEBPACK FOOTER //
// ./routes/app/components/Agent/AutomaticResponsesBtn/index.js